<div class="mu-section-header">
  <div class="mu-section-header--title">
    <h1>{{ title | translate }}</h1>
    <span class="mu-section-header--separator">{{ subTitleList && subTitleList.length > 0 ? ' / ':''  }}</span>
    <span>
      <p-breadcrumb [model]="subTitleList"></p-breadcrumb>
    </span>
  </div>
  <div class="mu-section-header--toolbar">
    <ng-content></ng-content>
  </div>
</div>
